function AddSubscriptionWidgetListeners()
{
    var widgets         = document.querySelectorAll( ".product-form .hh-ss-wrapper" );

    widgets.forEach( function( widget )
    {
        var widgetInputs   = widget.querySelectorAll( ".product-form .hh-ss-option .hh-subscription-option-input" );

        widgetInputs.forEach( function( widgetInput )
        {
            widgetInput.addEventListener( "input", SSWidgetOptionClick );
        } );

        HandleDefaultSellingPlanValue( widget );
    } );
}

function HandleDefaultSellingPlanValue( widget )
{
    var checkedInput                = widget.querySelector( "input.hh-subscription-option-input:checked" );
    var productForm                 = widget.closest( "form[ action='" + window.Shopify.routes.root + "cart/add' ]" );
    var productFormSellingPlanInput = productForm.querySelector( "input[ name='selling_plan' ]" );

    var productFormVariant          = productForm.querySelector( "input[name='id']" ).value;

    if( widget.getAttribute( "data-ss-variant" ) == productFormVariant )
    {
        var sellingPlanSelect           = widget.querySelector( ".hh-ss-product-selling-plans" );
        var selectedSellingPlan         = "";
    
        if( sellingPlanSelect )
        {
            selectedSellingPlan = sellingPlanSelect.options[ sellingPlanSelect.selectedIndex ].value;
        }
    
        if( productFormSellingPlanInput );
        {
            if( checkedInput.value == "subscribe" )
            {
                productFormSellingPlanInput.setAttribute( "value", selectedSellingPlan );
            }
            else if( checkedInput.value == "one-time" )
            {
                productFormSellingPlanInput.setAttribute( "value", selectedSellingPlan );
            }
        }
    }

    var forms = document.querySelectorAll( "form[ action='" + window.Shopify.routes.root + "cart/add' ]" );

    forms.forEach( function( form )
    {
        HandleFormButton( form, checkedInput );
    } );

}

function HandleDefaultPriceMessage( checkedInput )
{
    var form = checkedInput.closest( "form" );
    var subText = form.querySelector( "[data-subscription-message]");
    var oneTimeText = form.querySelector( "[data-one-time-message]");
    if( subText && oneTimeText )
    {
        if( checkedInput.value == "subscribe" )
        {
            subText.classList.remove( "hidden" );
            oneTimeText.classList.add( "hidden" );
        }
        else
        {
            subText.classList.add( "hidden" );
            oneTimeText.classList.remove( "hidden" );
        }
    }
}

function SSWidgetOptionClick( e )
{
    var checkedInput    = e.currentTarget;
    var widget          = checkedInput.closest( ".hh-ss-wrapper" );
    var ssOption        = checkedInput.closest( ".hh-ss-option" );

    var productForm                 = widget.closest( "form[ action='" + window.Shopify.routes.root + "cart/add' ]" );
    var productFormSellingPlanInput = productForm.querySelector( "input[ name='selling_plan' ]" );
    var productFormVariant          = productForm.querySelector( "input[name='id']" ).value;
    
    if( widget.getAttribute( "data-ss-variant" ) == productFormVariant )
    {
        var sellingPlanSelect           = ssOption.querySelector( ".hh-ss-product-selling-plans" );
        var selectedSellingPlan         = "";
    
        if( sellingPlanSelect )
        {
            selectedSellingPlan = sellingPlanSelect.options[ sellingPlanSelect.selectedIndex ].value;
        }
    
        if( productFormSellingPlanInput );
        {
            if( checkedInput.value == "subscribe" )
            {
                productFormSellingPlanInput.setAttribute( "value", selectedSellingPlan );
            }
            else if( checkedInput.value == "one-time" )
            {
                productFormSellingPlanInput.setAttribute( "value", selectedSellingPlan );
            }
        }

        HandleFormButton( productForm, checkedInput );
        ShowPrice( widget );
        HandleBundleCards( widget, checkedInput );
    }
    HandleDefaultPriceMessage( checkedInput );
}

function HandleFormButton( productForm, checkedInput )
{
    var buttons = productForm.querySelectorAll( ".hh-primary-button" );

    buttons.forEach( function( button )
    {
        if( checkedInput.value == "subscribe" )
        {
            button.classList.add( "btn-subscribe" );
        }
        else if( checkedInput.value == "one-time" )
        {
            button.classList.remove( "btn-subscribe" );
        }
    } );
}

function HandleBundleCards( widget, checkedInput )
{
    var widgetProduct               = widget.getAttribute( "data-ss-product" );
    var bundleProductCardTargets    = document.querySelectorAll( ".product_box[ data-ss-product='" + widgetProduct + "' ]" );

    if( bundleProductCardTargets && bundleProductCardTargets.length > 0 )
    {
        bundleProductCardTargets.forEach( function( bundleProductCardTarget )
        {
            var parent = bundleProductCardTarget.closest( ".bundle-product-wrapper" );
            ReallyHandleBundleCards( parent, widget, checkedInput );
        } );
    }
}

function ShowPrice( widget )
{

}

window.addEventListener( "load", function( e )
{
    AddSubscriptionWidgetListeners();
} );